import type { CallAnalysisTagDefinitionChoice } from '@reach/shared-types/call-analysis-tag-definitions';

export function buildChoice(
  value: string,
  color: string,
  textColor: string,
  icon: string,
): CallAnalysisTagDefinitionChoice {
  const trimmedValue = value.trim();
  const trimmedColor = color.trim();
  const trimmedTextColor = textColor.trim();
  const trimmedIcon = icon.trim();
  const out: CallAnalysisTagDefinitionChoice = { value: trimmedValue };
  if (trimmedColor) out.color = trimmedColor;
  if (trimmedTextColor) out.textColor = trimmedTextColor;
  if (trimmedIcon) out.icon = trimmedIcon;
  return out;
}

export function applyPendingChoiceEdit(
  choices: CallAnalysisTagDefinitionChoice[],
  editingChoiceValue: string,
  editingChoiceColor: string,
  editingChoiceTextColor: string,
  editingChoiceIcon: string,
): CallAnalysisTagDefinitionChoice[] {
  return choices.map(choice =>
    choice.value === editingChoiceValue
      ? buildChoice(choice.value, editingChoiceColor, editingChoiceTextColor, editingChoiceIcon)
      : choice,
  );
}
